// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

$(document).on('change', '#paper_type', function() {
  var paper_type = $(this);
  if (window.Turbo) {
    window.Turbo.visit('/papers/?paper_type=' + $(paper_type).val(), { target: '_self', action: 'advance' });
  } else {
    window.location.href = '/papers/?paper_type=' + $(paper_type).val();
  }
});

function initPaperForm() {
  // Initialize currency inputs
  if (typeof window.$ !== 'undefined' && $.fn.currencyInput) {
    $('input.currency').currencyInput();
  }
  
  // Load inventory if paper exists
  var paperId = $('[data-paper-id]').data('paper-id');
  if (paperId) {
    $.get('/papers/' + paperId + '/inventories');
  }
}

// Expose globally
window.initPaperForm = initPaperForm;

// Initialize on document ready
$(document).ready(function() {
  if($('form.paper-form, form[action*="papers"]').length > 0) {
    initPaperForm();
  }
});

// Initialize on Turbo events
$(document).on('turbo:load turbo:frame-load', function() {
  if($('form.paper-form, form[action*="papers"]').length > 0) {
    initPaperForm();
  }
});
